import { render } from "./AdminInviteAcceptPage.vue?vue&type=template&id=267bf3a5&scoped=true"
import script from "./AdminInviteAcceptPage.vue?vue&type=script&lang=js"
export * from "./AdminInviteAcceptPage.vue?vue&type=script&lang=js"

import "./AdminInviteAcceptPage.vue?vue&type=style&index=0&id=267bf3a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267bf3a5"]])

export default __exports__